import { render, staticRenderFns } from "./clueList.vue?vue&type=template&id=5271131c&scoped=true"
import script from "./clueList.vue?vue&type=script&lang=js"
export * from "./clueList.vue?vue&type=script&lang=js"
import style0 from "./clueList.vue?vue&type=style&index=0&id=5271131c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5271131c",
  null
  
)

export default component.exports